const escrowWalletES = {
    "view": {
        "title": "Gestiona tu Cartera de Depósito",
        "descriptionParagraph1": "Los fondos se retienen para garantizar la seguridad y transparencia durante el proceso de verificación. Para las pistas marcadas, se retiene una tarifa de <strong>15 €</strong> por pista en depósito para incluir la pista en la lista blanca para la entrega a Spotify. Estos fondos serán reembolsados una vez que los artistas de la pista sean verificados como legítimos.",
        "descriptionParagraph2": "Utiliza la tabla a continuación para ver todas las transacciones de depósito. Para más detalles, <1><strong>Aprende Más</strong></1>",
        "label": {
            "totalWithheld": "Total Retenido",
            "totalRefunds": "Total de Reembolsos"
        },
        "escrowPayments": {
            "title": "Pagos de Depósito",
            "table": {
                "column": {
                    "paymentId": "ID de Pago",
                    "releaseName": "Lanzamiento",
                    "amount": "Cantidad",
                    "paymentDate": "Fecha de Pago",
                    "paymentAgreement": "Acuerdo de Pago",
                    "refundProcessed": "Reembolso Procesado",
                    "requestRefund": "Solicitar Reembolso",
                    "details": "Detalles"
                },
                "placeholder": {
                    "search": "Buscar..."
                },
                "button": {
                    "download": "Descargar",
                    "exportCsv": "Exportar CSV",
                    "view": "Ver",
                    "requestRefund": "Solicitar Reembolso"
                },
                "label": {
                    "notAvailable": "No Disponible"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Solicitar Reembolso",
                        "body": {
                            "description": "¿Estás seguro de que deseas solicitar un reembolso para este pago?",
                            "note": "Por favor, ten en cuenta que esta solicitud está sujeta a revisión por parte del administrador y, si se aprueba, se añadirá como un estado para el cual puedes emitir una factura."
                        },
                        "button": {
                            "confirm": "Confirmar",
                            "cancel": "Cancelar"
                        },
                        "message": {
                            "success": "¡Solicitud de reembolso enviada con éxito!",
                            "error": "Algo salió mal, por favor intenta de nuevo más tarde."
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Desglose de Pagos de Depósito",
            "table": {
                "column": {
                    "paymentId": "ID de Pago",
                    "trackName": "Pista",
                    "amount": "Cantidad",
                    "paymentDate": "Fecha de Pago"
                }
            }
        },
        "escrowRefunds": {
            "title": "Reembolsos de Depósito",
            "table": {
                "column": {
                    "refundId": "ID de Reembolso",
                    "paymentId": "ID de Pago",
                    "release": "Lanzamiento",
                    "amount": "Cantidad",
                    "requestDate": "Fecha de Solicitud",
                    "status": "Estado"
                },
                "label": {
                    "pending": "Pendiente",
                    "approved": "Aprobado",
                    "rejected": "Rechazado"
                },
                "tooltip": {
                    "pending": "Tu solicitud de reembolso está actualmente pendiente de revisión por parte del administrador y será procesada pronto.",
                    "approved": "Tu solicitud de reembolso ha sido aprobada y se ha añadido un estado para el monto del reembolso.",
                    "rejected": "Tu solicitud de reembolso ha sido rechazada por el administrador, puedes solicitar el reembolso nuevamente."
                },
                "placeholder": {
                    "search": "Buscar..."
                },
                "button": {
                    "exportCsv": "Exportar CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transacción Exitosa :)",
            "description": "El pago de depósito se ha completado con éxito, ¡el lanzamiento relevante será incluido en la lista blanca en breve!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transacción Cancelada :(",
            "description": "La transacción fue cancelada... ¡Por favor intenta de nuevo más tarde!",
            "button": {
                "returnToDashboard": "Volver al Panel"
            }
        }
    }
};

export default escrowWalletES;